export default __webpack_public_path__ + "static/media/001-parasaurolophus.b3531f10.svg";